import React, { useState } from 'react';
import { Phone, Check } from 'lucide-react';
export function Contact() {
  const [showCopied, setShowCopied] = useState(false);
  const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Google Ads conversion event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-349742034/M8ECCPrSnrADENLH4qYB'
      });
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      const phoneNumber = '(818) 381-9905';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      }).catch(() => {
        window.location.href = 'tel:8183819905';
      });
    }
  };
  return <section className="w-full bg-gradient-to-b from-black to-zinc-950 py-20 px-4" id="contact" data-id="element-35" data-mp="gi5oxeo2se14">
      <div className="max-w-5xl mx-auto text-center" data-id="element-36" data-mp="bnjf3fxn6tj5">
        <h2 className="text-3xl md:text-5xl font-black uppercase text-white mb-2" data-id="element-37" data-mp="3jwmduv4wxv6t">
          Ready for a{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600" data-id="element-38" data-mp="3otctjhct2orp">
            Showroom Shine?
          </span>
        </h2>
        <p className="text-gray-400 text-lg mb-8" data-id="element-39" data-mp="3f4cpvkncz576">
          Book your mobile car detailing appointment today — serving Camarillo,
          Thousand Oaks, Simi Valley, Ventura, Agoura Hills, Calabasas Woodland
          Hills & Ventura County
        </p>

        <div className="flex flex-col items-center gap-8" data-id="element-40" data-mp="365hhc1wudj0p">
          <a href="tel:8183819905" onClick={handlePhoneClick} className="group relative flex flex-col items-center justify-center p-8 md:p-12 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-all duration-300 shadow-[0_0_40px_-10px_rgba(220,38,38,0.3)] hover:shadow-[0_0_60px_-10px_rgba(220,38,38,0.5)] cursor-pointer" aria-label="Call Mike's Pro Detail" data-id="element-41" data-mp="2s5gjkvbvirpg">
            <span className="text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-2 font-bold" data-id="element-42" data-mp="23c3o9ju0cvb0">
              Call or Text Mike
            </span>
            <div className="flex items-center gap-3 md:gap-6" data-id="element-43" data-mp="1yelnigq59me3">
              <Phone className="w-8 h-8 md:w-12 md:h-12 text-red-500 fill-red-500/20" data-id="element-44" data-mp="1ubxgmekzqpjr" />
              <span className="text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter group-hover:scale-105 transition-transform" data-id="element-45" data-mp="1pcktrtu4dih6">
                (818) 381-9905
              </span>
            </div>
            <div className="absolute -bottom-4 bg-black px-4 py-1 border border-zinc-800 rounded-full" data-id="element-46" data-mp="2i1rn8eepvhvk">
              <span className="text-green-500 font-bold uppercase text-sm flex items-center gap-2" data-id="element-47" data-mp="2d86zrgar26am">
                <span className="relative flex h-3 w-3" data-id="element-48" data-mp="28a5hgxl5eb07">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-49" data-mp="35qkpstpugnz5"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-50" data-mp="30yki2f3j8qs0"></span>
                </span>
                Available Now
              </span>
            </div>
          </a>

          {/* Copied to clipboard toast */}
          {showCopied && <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-51" data-mp="3i8wtpdgpfahx">
              <Check className="w-5 h-5" data-id="element-52" data-mp="3r9moqey54wul" />
              <span className="font-semibold" data-id="element-53" data-mp="3r8tmnra4mvis">
                Phone number copied to clipboard!
              </span>
            </div>}

          {/* Footer navigation: internal + external links */}
          <nav aria-label="Footer navigation" className="mt-12 pt-8 border-t border-zinc-900 w-full text-gray-500 text-sm" data-id="element-54" data-mp="4ua9tz0svoef">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-left mb-8" data-id="element-55" data-mp="9uxvs6a69f1s">
              {/* Services */}
              <div data-id="element-56" data-mp="itjdjz7tkq1i">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-57" data-mp="it07pgvg1s3u">
                  Detailing Services
                </h3>
                <ul className="space-y-2" data-id="element-58" data-mp="54zvfyyrckoa">
                  <li data-id="element-59" data-mp="15r0iqrzegr5">
                    <a href="/services/mobile-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-60" data-mp="1467j5lbf5ve">
                      Mobile Detailing
                    </a>
                  </li>
                  <li data-id="element-61" data-mp="9ykhcsn2to74">
                    <a href="/services/interior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-62" data-mp="9y2p073jbu4h">
                      Interior Detailing
                    </a>
                  </li>
                  <li data-id="element-63" data-mp="3edbymqnhqnm7">
                    <a href="/services/exterior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-64" data-mp="3ee3tfz99khbf">
                      Exterior Detailing
                    </a>
                  </li>
                  <li data-id="element-65" data-mp="3nes9t0m4qtrh">
                    <a href="/services/full-car-detail" className="hover:text-yellow-400 transition-colors" data-id="element-66" data-mp="17l1enxvt81sv">
                      Full Car Detail
                    </a>
                  </li>
                </ul>
              </div>

              {/* Service areas */}
              <div data-id="element-67" data-mp="2klxwbslh4icn">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-68" data-mp="2piwk7tejnt2e">
                  Service Areas
                </h3>
                <ul className="space-y-2" data-id="element-69" data-mp="2bkgg8a82ggny">
                  <li data-id="element-70" data-mp="2gi88x6gjc6t7">
                    <a href="/ventura-county/camarillo" className="hover:text-yellow-400 transition-colors" data-id="element-71" data-mp="2ghq4vnnmsoaq">
                      Camarillo
                    </a>
                  </li>
                  <li data-id="element-72" data-mp="3896189ezppe5">
                    <a href="/ventura-county/oxnard" className="hover:text-yellow-400 transition-colors" data-id="element-73" data-mp="389nvx1m07vjy">
                      Oxnard
                    </a>
                  </li>
                  <li data-id="element-74" data-mp="2zgkj8vj6nmqd">
                    <a href="/ventura-county/ventura" className="hover:text-yellow-400 transition-colors" data-id="element-75" data-mp="2zg2f7cqa447w">
                      Ventura
                    </a>
                  </li>
                  <li data-id="element-76" data-mp="3rxwsroyhspps">
                    <a href="/ventura-county/thousand-oaks" className="hover:text-yellow-400 transition-colors" data-id="element-77" data-mp="3ry6m9miqxf08">
                      Thousand Oaks
                    </a>
                  </li>
                </ul>
              </div>

              {/* Find us online (external links) */}
              <div data-id="element-78" data-mp="3ru690hjw250n">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-79" data-mp="3rtmp4vaoh6jz">
                  Find Us Online
                </h3>
                <ul className="space-y-2" data-id="element-80" data-mp="3iu9e3y6wo9x5">
                  <li data-id="element-81" data-mp="3ivay4s5wg6r0">
                    <a href="https://www.google.com/maps/search/Mike%27s+Pro+Detail+Ventura+County" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-82" data-mp="3iwm3gweztmk8">
                      Google Maps &amp; Reviews
                    </a>
                  </li>
                  <li data-id="element-83" data-mp="347g85jja0ghm">
                    
                  </li>
                  <li data-id="element-84" data-mp="2z5h2g302d7hi">
                    <a href="https://www.bbb.org/search?find_text=Mike%27s+Pro+Detail&find_loc=Ventura+County%2C+CA" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-85" data-mp="2z60o9usu4g0t"></a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-2 text-gray-600" data-id="element-86" data-mp="1emwsiklp9692">
              <p data-id="element-87" data-mp="1jlriq7lzxx37">
                © {new Date().getFullYear()} Mike's Pro Detail — Mobile Car
                Detailing Ventura County &amp; San Fernando Valley. All rights
                reserved.
              </p>
              <p data-id="element-88" data-mp="vxqgfgfevcw8">
                <a href="/#services" className="hover:text-gray-400 transition-colors" data-id="element-89" data-mp="vx8fw7lpucii">
                  Services
                </a>
                {' · '}
                <a href="/#service-areas" className="hover:text-gray-400 transition-colors" data-id="element-90" data-mp="10v9v2hg0trop">
                  Service Areas
                </a>
                {' · '}
                <a href="/#faq" className="hover:text-gray-400 transition-colors" data-id="element-91" data-mp="87w4r26tvudk">
                  FAQ
                </a>
              </p>
            </div>
          </nav>
        </div>
      </div>
    </section>;
}